import React from 'react';
import { View } from 'react-native';
import BaseText from '../BaseText';
import { CommonStyles, Color } from '../../styles';

const StopInfo = ({ type, time, detail }) => {
  return (
    <View style={CommonStyles.flex1}>
      <BaseText style={{ color: Color.grayText2 }}>{type}</BaseText>
      <BaseText style={CommonStyles.h1}>{time}</BaseText>
      <BaseText style={CommonStyles.h4}>{detail}</BaseText>
    </View>
  );
};

export default StopInfo;
